.elementsContainer {
  margin-bottom: 2em;
  position: relative;
}

.header {
  min-height: 100%;
  height: 2.75em;
  text-align: start;
  font-size: 1.1em;
  line-height: unset;
  display: block;

  & button {
    margin: 0;
    padding: 0.5em 3em;
    border: 0;
    background: transparent;
    max-width: 100%;
    font-weight: bold;
    text-transform: uppercase;
  }
}

.elementHeader {
  height: 2.75em;
  background-color: var(--blue);
  color: var(--white);
  margin-top: 1px;
  max-width: 100%;
  line-height: 1.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  & button {
    padding: 0.5em 1.5em;
    height: 100%;
  }

  & button::before {
    font-family: "hy-icons"; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
    content: "\EA71";
    margin-right: 0.5em;
  }

  & button.open::before {
    content: "\EA6D";
  }

  & .previewText {
    padding: 0.5em 1.5em;
    text-transform: none;
  }
}

.elementContent {
  border: var(--silver) solid 1px;
  padding: 1em;
  display: none;

  &.open {
    display: block;
  }
}

.elementInput {
  margin-top: 0.75em;
}

.addElementHeader {
  background-color: var(--silver);
  color: var(--blue);
  border-top: var(--blue) solid 1px;
  border-bottom: var(--blue) solid 1px;
}
